'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoIosEmailOutline = function IoIosEmailOutline(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm5 10h30v20h-30v-20z m15 10.9l12.7-9.6h-25.4z m-13.7 7.9h27.5v-16.8l-9 6.9 5.3 6-0.2 0.2-6.2-5.5-3.7 2.9-3.7-2.9-6.2 5.5-0.2-0.2 5.3-6-8.9-6.9v16.8z' })
        )
    );
};

exports.default = IoIosEmailOutline;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/ios-email-outline.js
// module id = 2628
// module chunks = 168707334958949